"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageMapper = void 0;
var models_1 = require("../models");
var LanguageMapper = /** @class */ (function () {
    function LanguageMapper() {
    }
    LanguageMapper.prototype.mapMultipleLanguages = function (response) {
        var _this = this;
        return response.languages.map(function (language) {
            return _this.mapLanguage(language);
        });
    };
    LanguageMapper.prototype.mapLanguage = function (language) {
        if (!language) {
            throw Error("Cannot map language");
        }
        return new models_1.Language({
            system: language.system
        });
    };
    return LanguageMapper;
}());
exports.LanguageMapper = LanguageMapper;
//# sourceMappingURL=language.mapper.js.map